export class Sticky {
  constructor($window){
      let win = angular.element($window); // wrap window object as jQuery object
      return {
          restrict: 'A',
          scope: {
            offset: '@',
            stickyClass: '@'
          },
          link: (scope, element, attrs) => {
              let offset = scope.offset || 0,
                  topClass = scope.stickyClass, // get CSS class from directive's attribute value
                  offsetTop = element.offset().top; // get element's offset top relative to document

              win.on('scroll', function (e) {
                  if (win.scrollTop() >= offsetTop + +offset) {
                      element.addClass(topClass);
                  } else {
                      element.removeClass(topClass);
                  }
              });
          }
      };
  }
}
